export const gonvarri = {
  gonvarri: {
    chapa: {
      quantity: {
        title: 'Por favor especifique cuántas chapas desea por paquete',
        warning: 'El peso del paquete será de aproximadamente ',
        minText: 'Valor mínimo',
        maxText: 'Valor máximo'
      },
      raw: {
        title: 'Para Paquetes de Peso Elegible, por favor especifique el peso máximo deseado por paquete (KG):',
        minText: 'El peso mínimo de los paquetes es de',
        maxText: 'El peso máximo de los paquetes es de'
      },
      ajustToStock: 'Ajustar al stock disponible',
    },
    productSummary: {
      quantity: 'Cantidad',
      price: 'Precio'
    },
    quick: {
      inputs: {
        length: 'Largo (MM)',
        sheets: 'Chapas / Paquete',
        lengthwarning: 'Por favor indicar el largo deseado (mm):',
        minlenght: 'Valor mínimo: {{minLenght}} mm',
        weight: 'Peso del Paquete (KG)',
        quantity: 'Cantidad de Paquetes',
        minWeight: 'Peso mín.',
        maxWeight: 'Peso máx.',
        packageWeight: 'Paquete de aprox.',
      },
      changeview: 'Para comprar por chapas',
      clickhere: 'click aquí'
    },
    company: {
      addresses: {
        default: 'Establecer como predeterminada'
      }
    },
    header: {
      company: {
        users: 'Usuarios',
        addresses: 'Libro de Direcciones'
      }
    },
    product: {
      notification: 'Notificarme cuando haya en stock',
      cancelNotification: 'No notificarme'
    }
  }
};
